import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import React from 'react';

const ReportErrors = ({ errors }) => {
  return (
    <div className={'flex text-red-500 items-center'}>
      <ErrorOutlinedIcon className="w-3 h-3 fill-white mr-2 animate-pulse" />
      <div className="text-xs">
        {errors?.map((item) => {
          return <p key={item}>{item}</p>;
        })}
      </div>
    </div>
  );
};

export default ReportErrors;
